import React from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";
import ComponentWrapper from "./ComponentWrapper";
import SubmitButton from "../UIComponents/SubmitButton";

const SuggestionBox = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const clickHandler = () => {
    history.push("/help");
  };
  return (
    <ComponentWrapper>
      <div className="p-2">{t("suggestionbox.label")}</div>
      <SubmitButton onClick={clickHandler}>
        {t("suggestionbox.button")}
      </SubmitButton>
    </ComponentWrapper>
  );
};

export default SuggestionBox;